















































































import { mapState } from "vuex";

import { Component, Vue, Watch } from "vue-property-decorator";
import { Content } from "@/interfaces/content";
import { Route } from "vue-router";
import { Tenant } from "@/interfaces/tenants";
import { TenantApiClient } from "@/api/tenant_client";
import { displayDate } from "@/date";
import CardComponent from "@/components/CardComponent.vue";

@Component({
  computed: {
    ...mapState(["tenants"])
  },
  components: { CardComponent }
})
export default class TenantVideos extends Vue {
  // Mapped from vuex
  tenants!: Tenant[];
  displayDate = displayDate;

  // Other Variables
  private api = new TenantApiClient();

  public tenant: Tenant = {
    name: "",
    description: "",
    web_url: "",
    tenant_id: ""
  };
  public contentType = "video";

  public contents: Content[] = [];
  public perPage = 50;
  public isLoading = true;

  public defaultThumbnailUrl: string =
    process.env.VUE_APP_DEFAULT_THUMBNAIL_URL;

  mounted() {
    this.setTenant(this.$route.params.tenant_id);
    this.loadContent();

    this.$store.commit("clearBreadcrumbs");
    this.$store.commit("pushBreadcrumbs", {
      to: `/tenant/${this.tenant.tenant_id}`,
      label: this.tenant.name
    });
    this.$store.commit("pushBreadcrumbs", {
      label: "Videos"
    });
  }

  // Watchers
  @Watch("$route")
  onRouteChange(newValue: Route) {
    this.setTenant(newValue.params.tenant_id);
    this.loadContent();
  }

  loadContent() {
    this.isLoading = true;
    this.api
      .listContent(this.tenant.tenant_id, this.contentType)
      .then(contents => {
        contents.forEach(content => {
          if (!content.thumbnail_url) {
            content.thumbnail_url = this.defaultThumbnailUrl;
          }
        });

        this.contents = contents;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  setTenant(tenantId: string) {
    this.tenants.forEach(tenant => {
      if (tenant.tenant_id === tenantId) {
        this.tenant = tenant;
      }
    });
  }
}
